<template>
  <vs-popup title="Vistorias" :active.sync="activeSync" @close="closeModal">
    <div v-if="hasValue(propostas)" class="listVeiculos">
      <div v-for="proposta in propostas" :key="proposta.idProposta">
        <div
          class="flex justify-between items-center"
          @click="redirectVistoriaV2(proposta.chave)"
        >
          <span class="font-semibold text-xl"
            >{{ proposta.idProposta }} - {{ proposta.dadosVeiculo.placa }}</span
          >
          <vs-chip
            class="chip py-2 my-4"
            :color="getStatusColor(proposta.idStatus)"
          >
            <vs-icon icon-pack="feather" size="small" icon="icon-camera" />
            <span class="font-medium text-lg px-2 text-uppercase">
              {{ getButtonText(proposta.idStatus) }}
            </span>
          </vs-chip>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { STATUS_COTACAO } from '../../commons/status-cotacao';
import { BP } from '../../commons/constant/empresasBp';
const URL_VISTORIA = 'https://vistoria.bemprotege.com.br';
export default {
  name: 'ModalListVistorias',
  props: {
    dados: {
      type: Array,
    },
    openModal: {
      type: Boolean,
    },
  },
  watch: {
    openModal(value) {
      if (value) {
        this.activeSync = value;
        this.propostas = this.dados;
      }
    },
  },
  data() {
    return {
      activeSync: false,
      statusCotacao: STATUS_COTACAO,
      propostas: [],
    };
  },

  methods: {
    closeModal() {
      (this.activeSync = false), this.$emit('close');
    },
    hasValue(array) {
      const value = array && array.length > 0;
      return value;
    },
    getStatusColor(status) {
      const statusColorMap = {
        1: 'primary',
        2: 'danger',
        3: 'warning',
        4: 'success',
        5: 'info',
        6: 'warning',
        7: 'warning',
      };

      return statusColorMap[status] || 'primary';
    },
    getButtonText(status) {
      const statusTextMap = {
        1: 'INICIAR VISTORIA',
        2: 'VISTORIA RECUSADA',
        3: 'AGUARDANDO APROVAÇÃO',
        4: 'VISTORIA APROVADA',
        5: 'VISTORIA COM PENDENCIA',
        6: 'EM PROCESSO DE VISTORIA',
        7: 'EM PRÉ-ANÁLISE',
      };
      return statusTextMap[status] || 'INICIAR VISTORIA';
    },
    redirectVistoriaV2(chave) {
      let url =
        this.propostas[0].idEmpresa === BP.ERP_GERAL
          ? URL_VISTORIA
          : window.location.origin.replace('adm', 'vistoria');

      if (window.location.origin.includes('localhost')) url = URL_VISTORIA;

      // Abrir o redirecionamento em outra aba
      window.open(`${url}/${chave}`, '_blank');
    },
  },
};
</script>
<style scoped>
div.listVeiculos > *:not(:last-child) {
  border-bottom: 1px solid rgba(128, 128, 128, 0.75);
}
span {
  text-transform: uppercase;
}

.chip {
  cursor: pointer;
  padding: 5px;
  font-size: 14px;
}
</style>
